import { render, staticRenderFns } from "./IndentedIncomePopup.vue?vue&type=template&id=1083ff3d&scoped=true"
import script from "./IndentedIncomePopup.vue?vue&type=script&lang=js"
export * from "./IndentedIncomePopup.vue?vue&type=script&lang=js"
import style0 from "./IndentedIncomePopup.vue?vue&type=style&index=0&id=1083ff3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1083ff3d",
  null
  
)

export default component.exports